import Hero from "../Components/Hero";
import Services from "../Components/Services";
import Bracket from "../Components/Bracket";
import Props from "../Components/Props";
import Roster from "../Components/Roster";
import LowFriction from "../Components/LowFriction";
import PickEm from "../Components/PickEm";
import Footer from "../Components/Footer";
import SportsData from "../Components/SportsData";

function Home() {
    return (
        <>
            <Hero></Hero>
            <Services></Services>
            <Bracket></Bracket>
            <Props></Props>
            <Roster></Roster>
            <LowFriction></LowFriction>
            <PickEm></PickEm>
            <Footer></Footer>
            <SportsData></SportsData>
        </>
    );
}

export default Home;
